import { api } from "../client";
import {
  DocumentOfferQuestionExtraFields,
  DocumentOfferQuestionFields,
  PartialDocumentOfferQuestionExtraFields,
  PartialDocumentOfferQuestionFields,
} from "../schema/DocumentOfferQuestion";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  DocumentOfferQuestionFields,
  DocumentOfferQuestionExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialDocumentOfferQuestionFields,
  PartialDocumentOfferQuestionExtraFields
>;

export const getDocumentOfferQuestions = async (config?: ApiRequestConfig) => {
  return api.get<DocumentOfferQuestionFields, DocumentOfferQuestionExtraFields>(
    "document_offer_questions",
    config
  );
};
export const getDocumentOfferQuestion = (
  id: number,
  config?: ApiRequestConfig
) => {
  return api.get<DocumentOfferQuestionFields, DocumentOfferQuestionExtraFields>(
    `document_offer_questions/${id}`,
    config
  );
};

export const createDocumentOfferQuestion = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialDocumentOfferQuestionFields,
    PartialDocumentOfferQuestionExtraFields
  >("document_offer_questions", config);
};
export const updateDocumentOfferQuestion = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialDocumentOfferQuestionFields,
    PartialDocumentOfferQuestionExtraFields
  >(`document_offer_questions/${id}`, config);
};
export const deleteDocumentOfferQuestion = (id: number) => {
  return api.remove<
    DocumentOfferQuestionFields,
    DocumentOfferQuestionExtraFields
  >(`document_offer_questions/${id}`);
};
